
const imageUrlDomain =
"https://uniprest-backend-public.s3.eu-central-1.amazonaws.com"

export const PRODUCT_PLACEHOLDER_IMAGE = "/images/product-placeholder.jpg"

export const getFullImageUrl = path =>
  (path ? `${imageUrlDomain}${path}` : '');
